var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorrisk = function SvgErrorrisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.586,
    height: 52.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11710"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11709"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c40d42",
    d: "M52.388 49.782 27.974.955a1.957 1.957 0 0 0-3.362 0L.2 49.782A1.878 1.878 0 0 0 1.88 52.5h48.827a1.878 1.878 0 0 0 1.681-2.717Zm-47.47-1.038L26.293 5.993l21.375 42.75Z",
    "data-name": "Path 6187"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11712"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11711"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c40d42",
    d: "M26.293 18.699a1.88 1.88 0 0 0-1.878 1.878v13.146a1.878 1.878 0 1 0 3.756 0V20.574a1.88 1.88 0 0 0-1.878-1.875",
    "data-name": "Path 6188"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11714"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11713"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c40d42",
    d: "M26.293 39.354a1.88 1.88 0 0 0-1.878 1.878v1.878a1.878 1.878 0 1 0 3.756 0v-1.878a1.88 1.88 0 0 0-1.878-1.878",
    "data-name": "Path 6189"
  })))));
};
export default SvgErrorrisk;